export const FEATURE_NAME = '@vshosting/cdn/features/warm-cache-dialog';
